import queryString from "query-string"
import moment from "moment"
import storage from "src/helpers/storage"
import debounce from "lodash/debounce"
import { LAST_SCROLL_POSITIONS, MONTH, SCALE_ZOOMS } from "../constants"

export const closeModal = ({ history, queryParams, planId }) => () => {
  if (planId) {
    history.push(
      `/plan/${planId}/calendar?${queryString.stringify(queryParams)}`,
    )
  } else {
    history.push(`/?${queryString.stringify(queryParams)}`)
  }
}

export const saveScrollState = debounce(
  (scaleName, values) => {
    const lastScroll = storage.get(LAST_SCROLL_POSITIONS) || {}
    lastScroll[scaleName] = values
    storage.set(LAST_SCROLL_POSITIONS, lastScroll)
  },
  150,
  {
    leading: false,
    trailing: true,
  },
)

/* This function provides maxZoom for timeline. Max zoom is taken from constants, but
 * if current scale is month it is not enough, as all months have different length.
 * For such cases maxZoom will be calculated as exact length of selected month in milliseconds
 * */
export const getMaxZoom = (calendarScale, calendarStartTime) => {
  let maxZoom = SCALE_ZOOMS[calendarScale].max
  if (calendarScale === MONTH) {
    const monthStart = moment(calendarStartTime).startOf(`month`)
    const monthEnd = moment(calendarStartTime).endOf(`month`)
    maxZoom = monthEnd.diff(monthStart).valueOf() - 1
  }
  return maxZoom
}
